
/**
Author - Babajan
Github - https://www.github.com/babajanpatan/
**/

function use12hrTimeFormat (time) {
  const [hours, minutes] = time.split(":");
  const suffix = hours >= 12 ? "PM" : "AM";
  const hours12 = hours % 12 || 12;
  return `${hours12}:${minutes} ${suffix}`;
}

export default use12hrTimeFormat;
